import React from 'react';
import { StylePropType } from '../../components';
import './popup.less';
import autobind from 'autobind-decorator';
import store from '../../store';
import { push } from '../../utils';
import PropTypes from 'prop-types';

interface EmptyViewPropType extends StylePropType {
    prefixCls?: string;
    data?: any;
    onClick?: any;
}

class PopupComp extends React.Component<EmptyViewPropType, any> {
    static defaultProps = {
        prefixCls: 'popupComp-com'
    };

    constructor(props, context) {
        super(props, context);
    }

    @autobind
    onContact() {
        if (store.status.gameApp) {
            push('/onlineservice', this);
        } else {
            window.location.href = 'https://xianlaihuyukefu.qiyukf.com/client?k=6dfc0f708ba3509992e8dbcabe3c6011&wp=1&gid=1192873&robotShuntSwitch=1&robotId=88062';
        }
    }

    render() {
        const {prefixCls, onClick, data} = this.props;
        return (
            <div className={`${prefixCls}container`}>
                <div className={`${prefixCls}close`} onClick={() => {
                    onClick();
                }}/>
                <div className={`${prefixCls}title`}>
                    如果您购买的商品出现问题，
                    <br/>
                    请尝试先和您的店主联系。
                </div>
                <div className={`${prefixCls}shopkeeper`}>{data.name || '国孕商城的店铺'}</div>
                <div className={`${prefixCls}shopkeeperPhone`}>店主电话</div>
                <a href={'tel:' + data.mobile}
                   className={`${prefixCls}shopkeeperPhoneNum`}>{data.mobile && data.mobile.replace(/(?=(\d{4})+$)/g, ' ')}</a>
                <div className={`${prefixCls}line`}/>
                <div className={`${prefixCls}title`}>若无法联系店主，请联系我们的客服</div>
                <div className={`${prefixCls}btn`} onClick={this.onContact}>联系在线客服</div>
                <div className={`${prefixCls}time`}>9:30-21:00</div>
                {/* <div className={`${prefixCls}line`}/>
                <a href={'tel:400-600-1805'} className={`${prefixCls}shopkeeperPhoneNum`}>400-600-1805</a>
                <div className={`${prefixCls}time`}>微信公众号：国孕商城（搜索guoyunshangcheng）</div> */}
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default PopupComp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/popup/popup.tsx